module.exports = __webpack_public_path__ + "static/section1-37bec9e809a64f37f7a05511d959f891.svg";